import { render, staticRenderFns } from "./UserShippingTypeCard.vue?vue&type=template&id=eefc336c"
import script from "./UserShippingTypeCard.vue?vue&type=script&lang=js"
export * from "./UserShippingTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports